import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

import restaurentBillingImg from "../assets/restaurentBilling.jpeg";

const RestaurentBilling = () => {
  return (
    <Container className="my-1">
      <Row
        style={{
          backgroundColor: "#0a5a6a",
        }}
      >
        <h2
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            backgroundColor: "transparent",
            width: "100%",
          }}
        >
          zpotter Technologies
        </h2>
      </Row>
      <Row className="align-items-center">
        <Col md={6}>
          <Image src={restaurentBillingImg} alt="1sAndOs" fluid />
        </Col>{" "}
        <Col
          md={6}
          style={{
            marginTop: "0.8rem",
            padding: "1rem",
            backgroundColor: "transparent",
            fontSize: "1rem",
          }}
        >
          <h2 style={{ color: "#0a5a6a" }}>
            {" "}
            Simplified Restaurant Billing Software
          </h2>
          <p style={{ textIndent: "3rem" }}>
            <ul>
              <li>Restaurants & Cafés</li>
              <li>Food Courts</li>
              <li>Bars & Pubs</li>
              <li>Cloud Kitchens (Dine-in)</li>
              <li>Hotels & Resorts</li>
            </ul>
          </p>
          <h4 style={{ color: "#0a5a6a" }}>
            Self Orders using QR codes - Smart and Faster{" "}
          </h4>
          <p style={{ textIndent: "1rem" }}>
            Our restaurant billing and order-placing software comes with a
            built-in QR code ordering feature that allows customers to place
            orders directly from their table using their own mobile phone—no app
            installation required.
          </p>
          <strong>How It Works</strong>
          <ol>
            <li> A unique QR code is placed on each table</li>
            <li>Customers scan the QR code using their mobile phone</li>
            <li>The restaurant’s menu opens instantly in the browser</li>
            <li>
              Customers select items and place orders directly from the table
            </li>
            <li>Orders are sent to the kitchen and billing system</li>
          </ol>
        </Col>{" "}
      </Row>{" "}
      {/* <Row className="align-items-center">
        <h2
          style={{
            color: "#0a5a6a",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {" "}
          Available Features
        </h2>
        <div
          style={{
            height: "100vh",
            backgroundColor: "#ecf3f2",
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${gymPic2})`, // Dims the background image
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <ul
            style={{
              color: "Yellow",
              display: "flex", // Apply flexbox
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically (optional)
              flexDirection: "column", // Align list items vertically
              listStyle: "none", // Remove bullets
              padding: "30px", // Optional: to remove default padding
            }}
          >
            <li>Mobile Attendance using QR code</li>
            <li>Member Registration using QR code</li>
            <li>Attendance Management</li>
            <li>Member Management</li>
            <li>Member Profile Picture</li>
            <li>Gym Visitors Tracker</li>
            <li>Member Payments Tracker</li>
            <li>Gym Equipments Management</li>
            <li>Accounts & Finance Management</li>
            <li>Multiple Gym Admins</li>
            <li>Daily, Weekly, Monthly Analytics</li>
            <li>Daily Trends</li>

            <li>Reports Download </li>
            <li>Member Invoice Download</li>
            <li>Multiple Software Themes</li>
            <li>Use in Multiple Devices - Laptop and Mobiles</li>
            <li>Android Mobile App</li>
            <li>Automatic WhatsApp Notifications to Members</li>
            <li>Automatic WhatsApp Reminders to Members</li>
            <li>Send WhatsApp Promotions</li>
            <li>Software is Available in English and Tamil Languages also</li>
          </ul>
        </div>
      </Row>{" "} */}
    </Container>
  );
};

export default RestaurentBilling;
